import { get, filter, size, slice, forEach, includes } from "lodash";

import { getSubEvent } from "./detectionDetails";
import { getAttributeValue } from "./profile";
import { getUser } from "./users";

import {
  HUMAN_DETECT,
  FACE_DETECT,
  CONTEXT,
  CONTEXT_LPR,
  LPR,
  CONTEXT_OCR,
  OCR,
} from "../constants/common";

export const getEventAttribute = (event, id) => {
  let res = "";
  if (event.attributes && event.attributes.length > 0) {
    res = event.attributes
      .filter((attr) => attr.id === id)
      .map((attr) => attr.value);
    res = res.length > 0 ? res[0] : "";
  }
  return res;
};

export const getOcrLprConfirmationCorrection = (
  element,
  detectionEventGroup
) => {
  let event;
  if (element.type === "OCR") {
    event = getSubEvent([71], detectionEventGroup);
    event.forEach((e) => {
      let matchRequestEvent = getSubEvent([62], e);
      matchRequestEvent.forEach((se) => {
        let croppedImg = getAttributeValue(se, 3);
        if (
          croppedImg === element.url ||
          includes(croppedImg, element.url) ||
          includes(element.url, croppedImg)
        ) {
          event = se;
        }
      });
    });
    // Get confirmation (76) and correction events (75)
    event = [...getSubEvent([76], event), ...getSubEvent([75], event)];
    event.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
  } else if (element.type === "LPR") {
    event = getSubEvent([72], detectionEventGroup);
    event.forEach((e) => {
      let matchRequestEvent = getSubEvent([56], e);
      matchRequestEvent.forEach((se) => {
        let croppedImg = getAttributeValue(se, 3);
        if (
          croppedImg === element.url ||
          includes(croppedImg, element.url) ||
          includes(element.url, croppedImg)
        ) {
          event = se;
        }
      });
    });
    // Get confirmation (78) and correction events (77)
    event = [...getSubEvent([78], event), ...getSubEvent([77], event)];
    event.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
  }

  return {
    ...element,
    events: event,
  };
};

export const getLatestValue = (event) => {
  let latestValue = "";
  let mostRecentEvent = {};
  if (event.events && event.events.length > 0) {
    mostRecentEvent = event.events.sort(
      (a, b) => new Date(b.created_on) - new Date(a.created_on)
    )[0];
    // Correction events
    if ([75, 77].includes(mostRecentEvent.type.id)) {
      latestValue = getAttributeValue(
        mostRecentEvent,
        event.type === "OCR" ? 50 : 44
      );
      if (!latestValue) {
        latestValue = event.values[0];
      }
    } else if (event.values && event.values.length > 0) {
      latestValue = event.values[0];
    }
  } else if (event.values && event.values.length > 0) {
    latestValue = event.values[0];
  }
  return [latestValue, mostRecentEvent];
};

/**
 * ex: hierachy = [8,7]
 * returns event type 7 child of events 8
 */
export const findEventTypeInTree = (eventGroup, hierachy) => {
  if (size(hierachy) === 0) {
    return null;
  } else if (size(hierachy) === 1) {
    return filter(
      get(eventGroup, ["events"]),
      (e) => get(e, ["type", "id"]) === get(hierachy, [0])
    );
  } else {
    return findEventTypeInTree(
      get(
        filter(
          get(eventGroup, ["events"]),
          (e) => get(e, ["type", "id"]) === get(hierachy, [0])
        ),
        [0]
      ),
      slice(hierachy, 1)
    );
  }
};

export const fetchCreatedByUsers = async (events) => {
  for (let i = 0; i < size(events); i++) {
    let e = get(events, [i]);
    if (e.created_by && !isNaN(parseInt(e.created_by))) {
      let usr = await getUser(e.created_by);
      e.created_by = `${get(usr, ["profile", "firstname"])} ${get(usr, [
        "profile",
        "lastname",
      ])}`;
    }
    if (size(get(e, ["events"])) > 0) {
      e.events = await fetchCreatedByUsers(get(e, ["events"]));
    }
  }
  return events;
};

export const getHumanIdentificationPhotos = (humanIdentification) => {
  let photos = [];
  forEach(get(humanIdentification, ["events"]), (e) => {
    forEach(get(e, ["images"]), (img) => {
      photos.push({
        url: img.url,
        type:
          get(e, ["type", "id"]) === 1
            ? HUMAN_DETECT
            : get(e, ["type", "id"]) === 2
            ? FACE_DETECT
            : "",
        values: [],
        matched:
          size(
            filter(get(e, ["events"]), (e) => get(e, ["type", "id"]) === 5)
          ) > 0,
      });
    });
  });
  return photos.sort((a, b) => {
    if (a.type === HUMAN_DETECT) return -1;
    if (a.matched) return -1;
    return 1;
  });
};

export const getVehicleIdentificationPhotos = (vehicleIdentification) => {
  const addImages = (photos, e) => {
    forEach(get(e, ["images"]), (img) => {
      let matched =
        get(img, ["sys_image_type_id"]) === 2 &&
        getAttributeValue(
          get(
            filter(get(e, ["events"]), (e) =>
              includes([57, 63], get(e, ["type", "id"]))
            ),
            [0]
          ),
          91
        );
      photos.push({
        url: img.url,
        type: includes([65, 66, 67, 68, 79, 80], get(e, ["type", "id"]))
          ? CONTEXT
          : get(e, ["type", "id"]) === 56 &&
            get(img, ["sys_image_type_id"]) === 1
          ? CONTEXT_LPR
          : get(e, ["type", "id"]) === 56 &&
            get(img, ["sys_image_type_id"]) === 2
          ? LPR
          : get(e, ["type", "id"]) === 62 &&
            get(img, ["sys_image_type_id"]) === 1
          ? CONTEXT_OCR
          : get(e, ["type", "id"]) === 62 &&
            get(img, ["sys_image_type_id"]) === 2
          ? OCR
          : "",
        values:
          get(img, ["sys_image_type_id"]) === 2
            ? [getAttributeValue(e, get(e, ["type", "id"]) === 56 ? 44 : 50)]
            : [],
        matched: matched || false,
      });
    });
  };

  let photos = [];
  forEach(get(vehicleIdentification, ["events"]), (e) => {
    addImages(photos, e);
    forEach(get(e, ["events"]), (ev) => {
      addImages(photos, ev);
    });
  });

  let finalPhotos = [];
  forEach(photos, (p) => {
    finalPhotos.push(getOcrLprConfirmationCorrection(p, vehicleIdentification));
  });

  return finalPhotos.sort((a, b) => {
    if (a.type === CONTEXT) return -1;
    if (a.matched) return -1;
    return 1;
  });
};
